import { render, staticRenderFns } from "./CustomerProductGallery.vue?vue&type=template&id=2bfcda66&scoped=true"
import script from "./CustomerProductGallery.vue?vue&type=script&lang=js"
export * from "./CustomerProductGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcda66",
  null
  
)

export default component.exports